var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm._onCheckInClick}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }